export default __webpack_public_path__ + "static/media/monsta-logo.492a8443.png";